import {
    EVIDENCE_ADD_REQUEST,
    EVIDENCE_ADD_RESPONSE,
    EVIDENCE_ITEM_DELETE_REQUEST,
    EVIDENCE_ITEM_DELETE_RESPONSE,
    EVIDENCE_ITEM_ERROR_RESPONSE,
    EVIDENCE_ITEM_SAVE_REQUEST,
    EVIDENCE_ITEM_SAVE_RESPONSE,
    EVIDENCE_LIST_CACHED_RESPONSE,
    EVIDENCE_LIST_ERROR_RESPONSE,
    EVIDENCE_LIST_REQUEST,
    EVIDENCE_LIST_RESPONSE,
    EVIDENCE_REMOVE_ITEM
} from "./action-types"
import { itemErrorResponse } from "./default-actions/entity-actions"
import { listErrorResponse } from "./default-actions/paging-actions"

export const evidenceAddRequest = (link, roleID) => ({
    type: EVIDENCE_ADD_REQUEST,
    link,
    roleID
})
export const evidenceAddResponse = (item, roleID) => ({
    type: EVIDENCE_ADD_RESPONSE,
    item,
    roleID
})
export const evidenceItemErrorResponse = itemErrorResponse(
    EVIDENCE_ITEM_ERROR_RESPONSE
)

export const evidenceRemoveItem = (item, roleID) => ({
    type: EVIDENCE_REMOVE_ITEM,
    item,
    roleID
})

export const evidenceItemSaveRequest = (item, stakeholderID, roleID) => ({
    type: EVIDENCE_ITEM_SAVE_REQUEST,
    item,
    stakeholderID,
    roleID
})

export const evidenceItemSaveResponse = (item, roleID) => ({
    type: EVIDENCE_ITEM_SAVE_RESPONSE,
    item,
    roleID
})

export const evidenceItemDeleteRequest = (
    evidenceID,
    stakeholderID,
    roleID
) => ({
    type: EVIDENCE_ITEM_DELETE_REQUEST,
    evidenceID,
    stakeholderID,
    roleID
})

export const evidenceItemDeleteResponse = (evidenceID, roleID) => ({
    type: EVIDENCE_ITEM_DELETE_RESPONSE,
    evidenceID,
    roleID
})

export const evidenceListRequest = (roleID, stakeholderID) => ({
    type: EVIDENCE_LIST_REQUEST,
    roleID,
    stakeholderID
})

export const evidenceListResponse = (data, roleID) => ({
    type: EVIDENCE_LIST_RESPONSE,
    data,
    roleID
})

export const evidenceListCachedResponse = roleID => ({
    type: EVIDENCE_LIST_CACHED_RESPONSE,
    roleID
})

export const evidenceListErrorResponse = listErrorResponse(
    EVIDENCE_LIST_ERROR_RESPONSE
)
